"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectChange = exports.dotNotationToObject = void 0;
function dotNotationToObject(dotNotation, value) {
    return dotNotation.split(".").reduceRight((acc, currentValue) => {
        return { [currentValue]: acc };
    }, value);
}
exports.dotNotationToObject = dotNotationToObject;
function getObjectChange(source, target) {
    const sourceKeys = Object.keys(source);
    const diff = {};
    sourceKeys.forEach((sourceKey) => {
        if (source[sourceKey] !== target[sourceKey])
            diff[sourceKey] = target[sourceKey];
    });
    return diff;
}
exports.getObjectChange = getObjectChange;
//# sourceMappingURL=objectUtils.js.map